import { render, staticRenderFns } from "./FeedTankCorrectionsList.vue?vue&type=template&id=f538d39e&"
import script from "./FeedTankCorrectionsList.vue?vue&type=script&lang=ts&"
export * from "./FeedTankCorrectionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports